import Dictionary from '../../../types/report/Dictionary';
import { getColumns } from './DictionaryBuilder.Grid';
import React from 'react';
import dataSourceHelper from '../../../infrastructure/helpers/functions/common/dataSourceHelper';
import dictionaryHelper from '../../../infrastructure/helpers/functions/dictionaries/dictionaryHelper';
import referenceValidator from '../../../infrastructure/helpers/functions/validator/referenceValidator';
import reportConfigNavigation from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import locationType from '../../../types/functions/Location/LocationType';
import ReportLogicLocation from '../../../types/functions/Location/ReportLogicLocation';
import ReportLogicList from '../Common/ReportLogicList/ReportLogicList';
import DictionaryBuilderProps from './DictionaryBuilderProps';
import ErrorList from '../../Common/ErrorList/ErrorList';
import ReportComponentStatus from '../Common/ReportComponentStatus/ReportComponentStatus';
import CustomDropdownOption from '../../Common/Dropdown/CustomDropdownOption';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import reportLogicReferenceHelper from '../../../infrastructure/helpers/functions/report/reportLogicReferenceHelper';
import Component from '../../../types/common/Component';
import { reportType } from '../../../infrastructure/constants/reportType';
import ComponentType from '../../../types/report/ComponentType';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import { buildText, prepareComponentType } from '../Common/ReferenceComponentHelper/ReferenceComponentHelper';
import { onReferenceSelected } from '../../../infrastructure/helpers/report/reference/helper';

class DictionaryBuilder extends React.Component<DictionaryBuilderProps> {

    constructor(props: DictionaryBuilderProps) {
        super(props);

        this.onNameChange = this.onNameChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.onDataSourceChange = this.onDataSourceChange.bind(this);
        this.onBusinessDescriptionChange = this.onBusinessDescriptionChange.bind(this);
        this.onRemoveDictionaryClick = this.onRemoveDictionaryClick.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getDictionryReferences = this.getDictionryReferences.bind(this);
        this.onReferenceSelected = this.onReferenceSelected.bind(this);
    }

    onNameChange(name: string, number: number): void {

        let location = this.getLocation(number, []);

        this.props.onChange(location, { name: name } as Dictionary);
    }

    onTypeChange(isMultiResult: boolean, number: number): void {

        let changes = { number: number } as Dictionary;

        let location = this.getLocation(number, []);

        let error = referenceValidator.validateDictionaryReferences(number, this.props.reportConfig);
        if (error) {

            changes.errors = [error];

            this.props.onChange(location, changes);

            return;
        }

        changes.isMultiResult = isMultiResult;

        this.props.onChange(location, changes);
    }

    onDataSourceChange(dataSourceId: string, number: number): void {

        let changes = {} as Dictionary;

        let location = this.getLocation(number, []);

        let error = referenceValidator.validateDictionaryReferences(number, this.props.reportConfig);
        if (error) {

            changes.errors = [error];

            this.props.onChange(location, changes);

            return;
        }

        let dataSource = dataSourceHelper.getById(this.props.collections.dataSources, parseInt(dataSourceId));

        changes.fields = [];

        dictionaryHelper.reset(changes, dataSource);

        this.props.onChange(location, changes);
    }

    onBusinessDescriptionChange(businessDescription: string, number: number): void {

        let location = this.getLocation(number, []);

        this.props.onChange(location, { businessDescription: businessDescription } as Dictionary);
    }

    onRemoveDictionaryClick(number: number): void {

        let location = this.getLocation(number, []);

        this.props.onRemoveClick(location);
    }

    getLocation(number: number, argumentIndexes: number[]): ReportLogicLocation {

        let location = {} as ReportLogicLocation;

        location.statement = locationType.statement.dictionary;
        location.statementNumber = number;
        location.argumentIndexes = argumentIndexes;

        return location;
    }

    getContent(dict: Dictionary): JSX.Element {

        return (
            <>
                <ErrorList errors={dict.errors} className="mt-2" />

                <ReportComponentStatus
                    reportType={this.props.reportConfig.type}
                    lastUpdatedTime={dict.lastUpdatedTime}
                    isReadOnly={this.props.isReadOnly} />
            </>)
    }


    async getDictionryReferences(number: number): Promise<CustomDropdownOption[]> {

        let config = copyObject(this.props.reportConfig);

        config.dictionaries = config.dictionaries.filter(x => x.number !== number);

        let references = reportLogicReferenceHelper.getDictionaryReferences(number, config, this.props.collections);

        let options: CustomDropdownOption[] = references.map((x) => { return { asUrl: false, component: { htmlId: x.value, name: x.text, componentType: x.componentType, componentNumber: x.number, reportConfigId: x.configId, componentInnerType: x.innerType, mainComponentNumber: x.mainComponentNumber } as Component } });

        if (this.props.reportConfig.type === reportType.globalModule) {

            let dict = this.props.reportConfig.dictionaries.find(x => x.number === number);

            if (dict?.id) {

                let component = { componentInnerType: ComponentType.Lookup, componentType: ComponentType.Dictionary, componentId: dict?.id, reportConfigId: config.id, componentNumber: dict?.number } as Component;

                let res = await httpClient.post('report/global-module/references', component);

                let refs = res.data as Component[];

                refs.forEach((ref) => {
                    ref.name = buildText(ref.reportConfigName || '', ref.name || '', ref.componentType);
                    options.push({
                        component: ref,
                        asUrl: true
                    } as CustomDropdownOption);
                });
            }
        }

        return options;
    }

    onReferenceSelected(option: CustomDropdownOption) {

        onReferenceSelected(option.component.htmlId || '');
    }

    render(): JSX.Element {
        return (
            <ReportLogicList
                isWaiting={this.props.isWaiting}
                items={this.props.reportConfig.dictionaries.filter(x => x.number === this.props.dictionaryNumber)}
                columns={getColumns(
                    this.onNameChange,
                    this.onTypeChange,
                    this.onDataSourceChange,
                    this.onBusinessDescriptionChange,
                    this.onRemoveDictionaryClick,
                    this.props.collections.dataSources,
                    this.props.isReadOnly,
                    this.props.reportConfig.id as number,
                    this.getDictionryReferences,
                    this.onReferenceSelected)
                }
                getContent={this.getContent}
                getKey={a => a.number}
                createHtmlId={v => reportConfigNavigation.buildDictionaryId(v.number)} />
        );
    }
}

export default DictionaryBuilder;
